import React from "react";
import GDCard from './GDCard';
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { getGDSearchlist } from "../Actions/GDLibraryAPI";

const searchData = { companyname: '', pagenumber: 1, pagesize: 10 };
const ConstSearchItem = { companyname: '', pagenumber: '', pagesize: 10 };
class GDLibrary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchDate: { companyname: '', pagenumber: 1, pagesize: 10 }, GDDelete: true
        }
        this.SearchGDData = this.SearchGDData.bind(this);
        this.ClearSearchField = this.ClearSearchField.bind(this);
    }
    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "GD Library" });
        this.props.dispatch(getGDSearchlist(this.state.searchDate));
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.GDisDeleted === true || nextProps.GDisUpdated === true || nextProps.IsGDDataAdded === true) {
            dispatch(getGDSearchlist(prevState.searchDate));
            dispatch({ type: "GDDelete", data: false })
            dispatch({ type: "GDUpdate", data: false })
            dispatch({
                type: "GDPostSuccessfull",
                data: false
            })
        }
    }
    SearchGDData(pgno) {
        const { dispatch } = this.props;
        this.state.searchDate['pagenumber'] = pgno;
        dispatch(getGDSearchlist(this.state.searchDate));
        dispatch({ type: "ResetGD", data: true })
    }
    SearchGDList(pgno) {
        const { dispatch } = this.props;
        this.state.searchDate['pagenumber'] = pgno;
        dispatch(getGDSearchlist(this.state.searchDate));
    }
    ClearSearchField() {
        // let param = { ...ConstSearchItem }
        // this.setState({
        //     searchDate: param
        // })
        this.state.searchDate.companyname = "";
        this.props.dispatch(getGDSearchlist(this.state.searchDate));
        this.setState({});
    }
    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.searchDate[nodeName] = e.target.value;
        this.setState({
        })
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    render() {
        const { arraylist, IsGDEdit } = this.props;
        console.log(arraylist)
        return (
            <div className="full-height w-100">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-4"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                {/* <div className="row mr-3 " style={{ height: "50px" }}>
                    {!IsGDEdit ? <div className="ml-auto m-3 nav-item-link" onClick={this.GDNewitemNav} style={{ color: "#109AFF" }}>New Item</div> : ''}
                </div> */}
                <div className="grey-bg  course-list-page">
                    <div className="px-4 pt-3">
                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                GD Library
                                </h5>
                                <div className="m-1 flex" onClick={this.GDNewitemNav}>
                                    <span className="mt-1">Add</span><AddIcon />
                                </div>
                            </div>
                        </div>
                        <div className="panel-box search-filter-box mb-3">
                            <div className="row" style={{ paddingBottom: '12px' }}>
                                {/* <div className={IsGDEdit ? "" : "col-lg-1"}></div> */}
                                <div className="col-lg-6">
                                    <label className="form-label" >Company Name</label><br></br>
                                    <input className="form-control" type="text" name="companyname" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.companyname}></input>
                                </div>
                                <div className={IsGDEdit ? "col-lg-6" : "col-lg-6"}>
                                    <label className="form-label" ><p></p></label><br></br>
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.SearchGDData(1)}> Search </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.ClearSearchField()}> Clear </button>
                                    </div>
                                </div>
                                <div className={IsGDEdit ? "" : "col-lg-1"}></div>
                            </div>
                        </div>
                        {arraylist ?
                            <GDCard arraylist={arraylist} pageSize={this.state.searchDate.pagesize} setUpdatedState={value => this.SearchGDList(value)} /> : null}

                    </div>
                </div>
            </div>
        ) 
    }
    GDNewitemNav = () => {
        this.props.dispatch({ type: 'GD Library', data: false });
        this.props.dispatch({ type: 'GDAttchmentUploadSuccess', data: null });
        this.props.history.push("/Home/GDNewItem")
    }
}
function mapStateToProps(state) {

    return {
        arraylist: state.SidePanReducer.GDListData,
        GDisDeleted: state.SidePanReducer.GDisDeleted,
        IsGDEdit: state.SidePanReducer.IsGDEdit,
        Refresh: state.SidePanReducer.Refresh,
        GDisUpdated: state.SidePanReducer.GDisUpdated,
        IsGDDataAdded: state.SidePanReducer.IsGDDataAdded
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GDLibrary);
